(() => {
  'use strict';
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-ceika-region-form]');
    if (!form) return;
    const returnTo = form.querySelector('[name="return_to"]');
    if (returnTo) {
      const url = new URL(location.href);
      const previewThemeId = form.dataset.ceikaPreviewThemeId;
      if (/^\d+$/.test(previewThemeId || '')) url.searchParams.set('preview_theme_id', previewThemeId);
      returnTo.value = url.pathname + url.search + url.hash;
    }
  }, true);
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-ceika-region][open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('[data-ceika-region][open]');
    if (menu) {
      menu.open = false;
      menu.querySelector('summary').focus();
    }
  });
})();
